import { action } from 'satcheljs';

// Reset all the values of store to initial default values
export const resetMovetoStore: () => {} = action('RESET_MOVETO_STORE');
